import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteDemoGym(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const mutationFn = (demoGymId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`demo-gyms/${demoGymId}/`);
  };

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['demoGyms'],
      });
    },
  });
}
